// Libs
import React, { useState } from "react";
import { useObserver, useRouter } from "@shoothill/core";
import { Box, Radio, Checkbox, Typography, useMediaQuery, makeStyles } from "@material-ui/core";
import { RadioSVG } from "Globals/Views/IconSVGs/RadioSVG";
import { RadioCheckedSVG } from "Globals/Views/IconSVGs/RadioCheckedSVG";

// App
import { SaveStatusContainer } from "Globals/Styles/SaveStyling";
import { StoresInstance } from "Globals/Stores";
const domainStores = StoresInstance.Domain;

export const SaveView: React.FC = () => {
    return useObserver(() => (
        <>
            <Box style={{ padding: "15px 0px" }}>
                <SaveStatusContainer className={domainStores.SaveStore.isSaving ? "saving" : ""}>
                    {domainStores.SaveStore.isSaving ? (
                        <>
                            <Typography variant={"body1"}>Saving</Typography>
                        </>
                    ) : (
                        <>
                            <Typography variant={"body1"}>Saved</Typography>
                        </>
                    )}
                    <Radio
                        className="save-checkbox"
                        checked={domainStores.SaveStore.isSaved}
                        icon={<RadioSVG width={28} height={28} />}
                        checkedIcon={<RadioCheckedSVG width={28} height={28} />}
                        disabled
                    />
                </SaveStatusContainer>
            </Box>
        </>
    ));
};
